import _ from 'lodash';
import { createActionHelpers } from 'vuex-loading';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_TABLE_CTX = 'UPDATE_TABLE_CTX';
export const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA';
export const ADD_FILTER_TO_MODEL = 'ADD_FILTER_TO_MODEL';
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_FIND_RESULT = 'UPDATE_FIND_RESULT';
export const UPDATE_SEARCHED_CLIENTS = 'UPDATE_SEARCHED_CLIENTS';

export const submitSearchColaboratorsAction = 'submitSearchColaboratorsAction';
export const resetSearchedColaboratorsAction = 'resetSearchedColaboratorsAction';
export const setFilterAction = 'setFilterAction';
export const changeErrorStatus = 'changeErrorStatus';
export const createClientAction = 'createClientAction';
export const searchByFilterAction = 'searchByFilterAction';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});


function colaboratorOperation(dates, ops, colaborators) {
  const matrix = {};
  _.forOwn(ops, (op) => {
    if (op && op.datesAssigments) {
      let colaborator;
      if (dates[op.datesAssigments].colaborador) {
        colaborator = dates[op.datesAssigments].colaborador;
        colaborator = colaborators.filter(e => e.id === colaborator);
        colaborator = colaborator[0];
        matrix[op.id] = {
          dates: dates[op.datesAssigments],
          colaborator,
          operation: op,
        };
      }
    }
  });
  return matrix;
}

async function proyectCollaboratorFromOperation(rootGetters, colaboradores) {
  const ops = await rootGetters['operation_model/entitiesGetter'];
  const dates = await rootGetters['datesAssignements_model/entitiesGetter'];
  const matrix = colaboratorOperation(dates, ops, colaboradores);
  const result = [];
  const resultIds = [];
  if (Object.keys(matrix).length > 0) {
    _.forOwn(matrix, (element) => {
      resultIds.push(element.colaborator.id);
      result.push({
        operacion: element.operation.title,
        nombre: element.colaborator.nombre,
        apellidos: element.colaborator.apellidos,
        empresa: element.colaborator.empresa,
        title: element.colaborator.title,
        importe: element.operation.nexumImporte,
        id: element.colaborator.id,
        operacionId: element.operation.id,
      });
    });
    if (resultIds && resultIds.length > 0) {
      colaboradores.forEach((e) => {
        if (resultIds.indexOf(e.id) < 0) {
          result.push(e);
        }
      });
    }
  }
  return result;
}

const initState = {
  error: '',
  loading: false,
  searchedColaborators: [],
  formModel: {
    filtro: '',
  },
  findResult: false,
  tableCtx: {
    currentPage: 1,
    perPage: 10,
    filter: '',
    sortBy: '',
    sortDesc: false,
  },
  tableData: [],
};

export default {
  namespaced: true,
  state: Object.assign({}, initState),
  mutations: {
    [CLEAR_MODULE](state) {
      Object.assign(state, initState);
    },
    [UPDATE_LOADING](state, loading) {
      state.loading = loading;
    },
    [UPDATE_ERROR](state, msg) {
      state.error = msg;
    },
    [UPDATE_TABLE_CTX](state, model) {
      state.tableCtx = Object.assign({}, state.tableCtx, model);
    },
    [ADD_FILTER_TO_MODEL](state, filter) {
      state.formModel.filtro = filter;
    },
    [UPDATE_TABLE_DATA](state, lista) {
      state.tableData = lista;
    },
    [UPDATE_SEARCHED_CLIENTS](state, lista) {
      state.searchedClients = lista;
    },
    [UPDATE_FIND_RESULT](state, payload) {
      state.findResult = payload;
    },
    [UPDATE_FORM_DATA](state, payload) {
      payload.filtro = state.formModel.filtro;
      state.formModel = payload;
    },
  },
  actions: {
    [submitSearchColaboratorsAction]({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'buscarColaborador');
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      commit(UPDATE_FORM_DATA, payload);
      const fetchConfig = {};
      _.forOwn(payload, (value, key) => {
        if (value && value !== '') {
          if (key === 'nombre') {
            fetchConfig.nombreFilter = {
              modelName: 'nombre',
              operator: 'CONTAINS',
              value,
              path: 'collaborator_name',
            };
          } else if (key === 'apellidos') {
            fetchConfig.apellidosFilter = {
              modelName: 'apellidos',
              operator: 'CONTAINS',
              value,
              path: 'collaborator_surname',
            };
          } else if (key === 'empresa') {
            fetchConfig.empresaFilter = {
              value,
              path: 'empresa',
              operator: 'CONTAINS',
              modelName: 'empresa',
            };
          }
        }
      });
      return dispatch('collaborator_model/fetchAction', fetchConfig, { root: true })
        .then(results => proyectCollaboratorFromOperation(rootGetters, results.entities))
        .then((entities) => {
          if (entities.length <= 0) {
            commit(UPDATE_TABLE_DATA, []);
          } else {
            commit(UPDATE_TABLE_DATA, entities);
          }
          commit(UPDATE_LOADING, false);
          commit(UPDATE_FIND_RESULT, true);
          endLoading(dispatch, 'buscarColaborador');
        })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscarColaborador');
        });
    },
    [changeErrorStatus]({ commit }, msg) {
      commit(UPDATE_ERROR, msg);
    },
    [resetSearchedColaboratorsAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
    [searchByFilterAction]({ commit, dispatch, rootGetters }) {
      startLoading(dispatch, 'buscarColaborador');
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      dispatch('datesAssignements_model/fetchAction', {
        uuid: {
          operator: 'IS NOT NULL',
          path: 'colaborador.uuid',
          parent: 'node--date_assignement',
          parentProperty: 'colaborador',
        },
      }, { root: true }).then((res) => {
        const { entities } = res;
        if (Array.isArray(entities) && entities.length > 0) {
          proyectCollaboratorFromOperation(rootGetters, entities)
            .then((results) => {
              if (results.length <= 0) {
                commit(UPDATE_TABLE_DATA, []);
              } else {
                commit(UPDATE_TABLE_DATA, results);
              }
              commit(UPDATE_LOADING, false);
            });
        } else {
          commit(UPDATE_TABLE_DATA, []);
        }
        commit(UPDATE_LOADING, false);
        commit(UPDATE_FIND_RESULT, true);
        endLoading(dispatch, 'buscarColaborador');
      })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscarColaborador');
        });
    },
  },
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    existError: state => state.error !== '',
    searchedColaborators: state => state.tableData,
    findResult: state => state.findResult,
  },
};



// WEBPACK FOOTER //
// ./src/features/menu-colaboradores/store.js